module.exports = __webpack_public_path__ + "svg/social-google.svg?a8e614894d83ee5cb5ec4f876db45103";